import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/admin-settings/global-settings/")({
  component: lazyImportRouteComponent(
    () => import("./-components/GlobalSettingsPage"),
    "GlobalSettingsPage"
  ),
})
